@import "../user-prompts";

.confirmation-modal {
  .modal-backdrop {
    .modal-dialog {
      .modal-content {
        .modal-header {
          .modal-title {
          }
        }
        .modal-body {
          .text {
            padding: 12% 12% 2% 12%;
          }
          .files-header {
            padding: 10px 0;
            color: #8491A2;
          }
        }
        .modal-footer {
          padding-left: 40px;
          padding-right: 40px;
          .btn-container {
            width: 100%;
            display: flex;
            .yes {
              @include footerButton(#1E944F);
              width: 45%;
              &.disable {
                opacity: .4;
                pointer-events: none;
              }
            }
            .seperator {
              width: 10%;
            }
            .no {
              @include footerButton(#900035);
              width: 45%;
            }
          }
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/user-prompts/confirmation-modal/confirmation-modal.scss